(function(){
  if ((window.__cfLoaded = window.__cfLoaded || {})['cf-product-label']) return;
  window.__cfLoaded['cf-product-label'] = true;
function buildLaserSvg(opts) {
  function esc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
  }
  var title = (opts.title || "").toUpperCase();
  var subline = (opts.subline || "").toUpperCase();
  var coords = opts.showCoords ? opts.coords || "" : "";
  var titleForDesc = title || "(blank)";
  var hasCoord = !!coords;
  var nameX = hasCoord ? "3" : "28.8";
  var nameAnchor = hasCoord ? "" : ' text-anchor="middle"';
  var engraveLines;
  if (subline) {
    engraveLines = '    <text class="parent" x="' + nameX + '" y="2.91"' + nameAnchor + ">" + esc(title) + '</text>\n    <text class="locality" x="' + nameX + '" y="5.81"' + nameAnchor + ">" + esc(subline) + "</text>";
  } else {
    engraveLines = '    <text class="name-1" x="' + nameX + '" y="4.70"' + nameAnchor + ">" + esc(title) + "</text>";
  }
  var coordLine = hasCoord ? '\n    <text class="coord" x="54.6" y="4.46" text-anchor="end">' + esc(coords) + "</text>" : "";
  var dividerLine = hasCoord ? '    <line class="engraved-stroke" x1="32.6" y1="1.9" x2="32.6" y2="5.7"/>\n' : "";
  return '<?xml version="1.0" encoding="UTF-8"?>\n<svg xmlns="http://www.w3.org/2000/svg"\n     xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"\n     width="57.6mm" height="7.6mm"\n     viewBox="0 0 57.6 7.6"\n     version="1.1">\n  <title>Cityform laser label \u2014 ' + esc(titleForDesc) + `</title>
  <desc>57.6 x 7.6 mm. Design system v1.1. Convert text to paths in Inkscape before importing to xTool XCS.</desc>
  <defs>
    <style type="text/css">
      .plate { fill: #2C313A; }
      .engraved-stroke { stroke: #C8CCD0; stroke-width: 0.25; }
      .name-1 { font-family: 'Inter', 'Helvetica Neue', Arial, sans-serif; font-weight: 600; font-size: 2.4px; letter-spacing: 0.28px; fill: #C8CCD0; }
      .parent { font-family: 'Inter', 'Helvetica Neue', Arial, sans-serif; font-weight: 600; font-size: 1.55px; letter-spacing: 0.45px; fill: #C8CCD0; }
      .locality { font-family: 'Inter', 'Helvetica Neue', Arial, sans-serif; font-weight: 600; font-size: 2.0px; letter-spacing: 0.18px; fill: #C8CCD0; }
      .coord { font-family: 'Inter', 'Helvetica Neue', Arial, sans-serif; font-weight: 400; font-size: 1.8px; letter-spacing: 0.16px; fill: #C8CCD0; }
      .cut-line { fill: none; stroke: #FF0000; stroke-width: 0.01; }
    </style>
  </defs>
  <g id="engrave" inkscape:label="engrave" inkscape:groupmode="layer">
    <rect class="plate" x="0" y="0" width="57.6" height="7.6" rx="3.8" ry="3.8"/>
` + dividerLine + engraveLines + coordLine + '\n  </g>\n  <g id="cut" inkscape:label="cut" inkscape:groupmode="layer">\n    <rect class="cut-line" x="0" y="0" width="57.6" height="7.6" rx="3.8" ry="3.8"/>\n  </g>\n</svg>\n';
}
function hasUnsupportedChars(s) {
  return /[^A-Za-z0-9 .,&\-’]/.test(String(s || ""));
}
function normaliseEngravingInput(s) {
  return String(s || "").replace(/'/g, "\u2019").replace(/[^A-Za-z0-9 .,&\-’]/g, "").toUpperCase();
}
function titleMaxFor(hasSubline, hasCoord) {
  if (hasCoord) return hasSubline ? 16 : 14;
  return hasSubline ? 28 : 24;
}
function sublineMaxFor(hasCoord) {
  return hasCoord ? 18 : 31;
}
const _BANNED_WORDS = [
  // English profanity
  "fuck",
  "shit",
  "cunt",
  "piss",
  "wank",
  "twat",
  "prick",
  "dick",
  "cock",
  "pussy",
  "bollocks",
  "bastard",
  "asshole",
  "arsehole",
  "motherfucker",
  "bullshit",
  // Slurs — the highest-cost ones to engrave by mistake
  "nigger",
  "nigga",
  "faggot",
  "fag",
  "spic",
  "kike",
  "chink",
  "gook",
  "wetback",
  "tranny",
  "retard",
  "retarded",
  "spastic",
  // Hateful symbols spelled out
  "nazi",
  "hitler",
  "kkk"
];
function _normaliseForFilter(s) {
  return String(s || "").toLowerCase().replace(/(?<=[a-z])[._\-*+/\\@#$]+(?=[a-z])/g, "");
}
function findBannedWord(text) {
  const n = _normaliseForFilter(text);
  for (const w of _BANNED_WORDS) {
    const pattern = "\\b" + w.split("").map((c) => c + "{1,3}").join("") + "\\b";
    if (new RegExp(pattern, "i").test(n)) return w;
  }
  return null;
}
function BaseColorSelector({ value, onChange, disableWhite, inForm }) {
  const wh = !disableWhite;
  const btn = function(color, label, swatchHex) {
    const selected = value === color;
    const enabled = color === "black" || wh;
    const onClick = function() {
      if (enabled && !selected) onChange(color);
    };
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        onClick,
        disabled: !enabled,
        "aria-pressed": selected,
        title: !enabled ? "Available for these cities in v2 \u2014 meanwhile commission via the picker" : "",
        style: {
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          padding: "9px 14px",
          background: selected ? "var(--ink, #1A1F26)" : "transparent",
          color: !enabled ? "var(--stone, #888)" : selected ? "var(--bone, #F7F8F6)" : "var(--ink, #1A1F26)",
          border: "1px solid " + (!enabled ? "var(--stone, #888)" : "var(--ink, #1A1F26)"),
          fontFamily: "Inter, sans-serif",
          fontSize: 12,
          fontWeight: 500,
          cursor: enabled ? "pointer" : "not-allowed",
          opacity: enabled ? 1 : 0.55,
          transition: "background 120ms, color 120ms"
        }
      },
      /* @__PURE__ */ React.createElement("span", { style: {
        width: 14,
        height: 14,
        borderRadius: 2,
        background: swatchHex,
        border: "1px solid " + (swatchHex === "#F0EFEA" ? "rgba(0,0,0,0.2)" : "transparent"),
        display: "inline-block",
        flexShrink: 0
      } }),
      label
    );
  };
  return /* @__PURE__ */ React.createElement("div", { style: {
    marginBottom: inForm ? 16 : 24,
    paddingBottom: inForm ? 16 : 24,
    borderBottom: "1px solid var(--line, #ddd)"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontFamily: "Inter, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: "0.28em",
    textTransform: "uppercase",
    color: "var(--ink, #1A1F26)",
    marginBottom: 10
  } }, "Base colour"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, flexWrap: "wrap" } }, btn("black", "Black", "#1A1F26"), btn("white", "White", "#F0EFEA")), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--stone, #888)", marginTop: 8, lineHeight: 1.5 } }, !wh ? /* @__PURE__ */ React.createElement(React.Fragment, null, "White available via the ", /* @__PURE__ */ React.createElement("a", { href: "/products/commission-your-city", style: { color: "var(--ink, #1A1F26)", textDecoration: "underline" } }, "commission picker"), ".") : /* @__PURE__ */ React.createElement(React.Fragment, null, "Both colours ship free. The 3D preview updates instantly when you change.")));
}
function CfProductLabel({ handle, defaults, inline, suppressBaseSelector }) {
  const cfp = typeof window !== "undefined" && window.cfPaths || {};
  let cfProd = cfp.products && cfp.products[handle] || null;
  if (!cfProd && cfp.products && handle) {
    const keys = Object.keys(cfp.products).sort((a, b) => b.length - a.length);
    for (const k of keys) {
      if (handle === k || handle.indexOf(k + "-") === 0) {
        cfProd = cfp.products[k];
        break;
      }
    }
  }
  const d = {
    title: cfProd && cfProd.title || defaults && defaults.title || "",
    subline: cfProd && cfProd.subline || defaults && defaults.subline || "",
    coords: defaults && defaults.coords || cfProd && cfProd.coord || "",
    // showCoords: not in cfPaths.products → respect Liquid default (true unless explicit false)
    showCoords: defaults && defaults.showCoords === false ? false : true
  };
  const initialCoordsOn = d.showCoords !== false;
  const [personalise, setPersonalise] = React.useState(false);
  const [baseColor, setBaseColor] = React.useState("black");
  const [title, setTitle] = React.useState(normaliseEngravingInput(d.title || "").slice(0, titleMaxFor(!!d.subline, initialCoordsOn)));
  const [subline, setSubline] = React.useState(normaliseEngravingInput(d.subline || "").slice(0, sublineMaxFor(initialCoordsOn)));
  const [showCoords, setShowCoords] = React.useState(initialCoordsOn);
  const [form, setForm] = React.useState(null);
  const [titleError, setTitleError] = React.useState(null);
  const [sublineError, setSublineError] = React.useState(null);
  const [modError, setModError] = React.useState(null);
  const [modPending, setModPending] = React.useState(false);
  const validatedRef = React.useRef(false);
  const [stripHint, setStripHint] = React.useState(false);
  const stripHintTimerRef = React.useRef(null);
  function flagStripHint() {
    setStripHint(true);
    if (stripHintTimerRef.current) clearTimeout(stripHintTimerRef.current);
    stripHintTimerRef.current = setTimeout(function() {
      setStripHint(false);
    }, 5e3);
  }
  React.useEffect(function() {
    return function() {
      if (stripHintTimerRef.current) clearTimeout(stripHintTimerRef.current);
    };
  }, []);
  const [portalHost, setPortalHost] = React.useState(null);
  const [anchorFailed, setAnchorFailed] = React.useState(false);
  const coords = d.coords || "";
  const titleMax = titleMaxFor(!!subline, showCoords);
  const sublineMax = sublineMaxFor(showCoords);
  React.useEffect(function() {
    var tmax = titleMaxFor(!!subline, showCoords);
    if (title.length > tmax) setTitle(title.slice(0, tmax));
    var smax = sublineMaxFor(showCoords);
    if (subline.length > smax) setSubline(subline.slice(0, smax));
  }, [subline, showCoords]);
  React.useEffect(function() {
    if (typeof window === "undefined") return;
    var t = setTimeout(function() {
      window.dispatchEvent(new CustomEvent("cf:label-change", {
        detail: {
          handle: handle || "",
          title: title || "",
          subline: subline || "",
          coord: coords || "",
          showCoords: showCoords !== false
        }
      }));
    }, 120);
    return function() {
      clearTimeout(t);
    };
  }, [handle, title, subline, showCoords, coords]);
  React.useEffect(function() {
    function find() {
      return document.querySelector(
        'product-form form[action*="/cart/add"], form[action*="/cart/add"]'
      );
    }
    var hit = find();
    if (hit) {
      setForm(hit);
      return;
    }
    var n = 0;
    var t = setInterval(function() {
      n++;
      var h = find();
      if (h || n > 50) {
        clearInterval(t);
        if (h) setForm(h);
      }
    }, 100);
    return function() {
      clearInterval(t);
    };
  }, []);
  React.useEffect(function() {
    if (!form) return;
    function findAnchor() {
      return form.querySelector('[data-block-type="buy-buttons"]') || form.querySelector("buy-buttons-component") || form.querySelector("accelerated-checkout-buttons") || (function() {
        var addBtn = form.querySelector('[name="add"]');
        return addBtn ? addBtn.closest('buy-buttons-component, [data-block-type="buy-buttons"], .product-form-buttons, div') : null;
      })() || (function() {
        var sub = form.querySelector('button[type="submit"]');
        return sub ? sub.parentElement : null;
      })();
    }
    var host = null, t = null, n = 0;
    function tryInsert() {
      var anchor = findAnchor();
      if (!anchor || !anchor.parentNode) {
        if (n++ < 30) {
          t = setTimeout(tryInsert, 100);
        } else {
          setAnchorFailed(true);
        }
        return;
      }
      host = document.createElement("div");
      host.className = "cf-product-label-portal";
      anchor.parentNode.insertBefore(host, anchor);
      setPortalHost(host);
    }
    tryInsert();
    return function() {
      if (t) clearTimeout(t);
      if (host && host.parentNode) host.parentNode.removeChild(host);
    };
  }, [form]);
  React.useEffect(function() {
    if (!form) return;
    function onSubmit(e) {
      if (validatedRef.current) return;
      if (!personalise) {
        validatedRef.current = true;
        return;
      }
      if (titleError || sublineError) {
        e.preventDefault();
        e.stopPropagation();
        setModError("Please remove the highlighted text above to continue.");
        return;
      }
      const fullText = (title + " " + subline).trim();
      if (!fullText) {
        validatedRef.current = true;
        return;
      }
      var endpoint = window.cfPaths && window.cfPaths.moderate || null;
      if (!endpoint) {
        validatedRef.current = true;
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      setModPending(true);
      setModError(null);
      fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ text: fullText })
      }).then(function(r) {
        return r.ok ? r.json() : null;
      }).then(function(d2) {
        setModPending(false);
        if (d2 && d2.flagged) {
          setModError(
            "This text was flagged by content moderation" + (d2.reason ? " (" + d2.reason + ")" : "") + ". Please adjust the wording."
          );
          return;
        }
        validatedRef.current = true;
        form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
      }).catch(function() {
        setModPending(false);
        validatedRef.current = true;
        form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
      });
    }
    form.addEventListener("submit", onSubmit, true);
    return function() {
      form.removeEventListener("submit", onSubmit, true);
    };
  }, [form, personalise, title, subline, titleError, sublineError]);
  React.useEffect(function() {
    if (suppressBaseSelector) return;
    try {
      window.dispatchEvent(new CustomEvent("cf:base-color-change", {
        detail: { color: baseColor }
      }));
    } catch (_e) {
    }
  }, [baseColor, suppressBaseSelector]);
  const displayTitle = (personalise ? title : d.title || "").toUpperCase();
  const displaySubline = (personalise ? subline : d.subline || "").toUpperCase();
  const displayShowCoords = personalise ? showCoords : initialCoordsOn;
  const inForm = !!portalHost;
  const wrapperStyle = inForm ? { padding: "24px 0", borderTop: "1px solid var(--line, #ddd)", borderBottom: "1px solid var(--line, #ddd)", margin: "20px 0" } : { padding: "64px 24px", background: "var(--mist, #EEEFEB)", borderTop: "1px solid var(--ink, #1A1F26)", borderBottom: "1px solid var(--ink, #1A1F26)" };
  const innerStyle = inForm ? { maxWidth: "100%" } : { maxWidth: 980, margin: "0 auto" };
  const headingFontSize = inForm ? 18 : "clamp(28px, 4vw, 40px)";
  const headingMb = inForm ? 6 : 8;
  const subFontSize = inForm ? 13 : 14;
  const subMb = inForm ? 16 : 28;
  const previewPad = inForm ? "20px 16px" : "48px 32px";
  const ui = /* @__PURE__ */ React.createElement("div", { className: "cf-product-label", style: wrapperStyle }, /* @__PURE__ */ React.createElement("div", { style: innerStyle }, !suppressBaseSelector ? /* @__PURE__ */ React.createElement(BaseColorSelector, { value: baseColor, onChange: setBaseColor, disableWhite: false, inForm }) : null, /* @__PURE__ */ React.createElement("div", { style: {
    display: "inline-block",
    padding: "6px 12px",
    marginBottom: 12,
    background: "var(--ink, #1A1F26)",
    color: "var(--bone, #F7F8F6)",
    fontFamily: "Inter, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: "0.28em",
    textTransform: "uppercase"
  } }, personalise ? "Personalising \xB7 +\xA33" : "Standard engraving free \xB7 Personalise +\xA33"), /* @__PURE__ */ React.createElement("h2", { className: "h1", style: {
    fontSize: headingFontSize,
    marginTop: 0,
    marginBottom: headingMb,
    fontWeight: 600,
    letterSpacing: "-0.012em"
  } }, "How yours will read."), /* @__PURE__ */ React.createElement("p", { style: { fontSize: subFontSize, color: "var(--ink-soft, #6E7479)", lineHeight: 1.55, marginTop: 0, marginBottom: subMb, maxWidth: inForm ? "100%" : 640 } }, "Engrave any text \u2014 city + coords, a name, a date, a family motto. Two lines = smaller above, larger below. One line = single large centred line."), /* @__PURE__ */ React.createElement("div", { className: "cf-preview-pad", style: {
    background: "var(--bone)",
    border: "1px solid var(--line)",
    padding: previewPad,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } }, /* @__PURE__ */ React.createElement("div", { style: { width: "100%", maxWidth: 600, aspectRatio: "57.6 / 7.6" } }, /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox: "0 0 57.6 7.6",
      width: "100%",
      height: "100%",
      preserveAspectRatio: "xMidYMid meet",
      style: { display: "block", filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.18))" }
    },
    /* @__PURE__ */ React.createElement("rect", { x: "0", y: "0", width: "57.6", height: "7.6", rx: "3.8", ry: "3.8", fill: "#2C313A" }),
    displayShowCoords && coords ? /* @__PURE__ */ React.createElement("line", { x1: "32.6", y1: "1.9", x2: "32.6", y2: "5.7", stroke: "#C8CCD0", strokeWidth: "0.25" }) : null,
    /* @__PURE__ */ (() => {
      const hasCoord = !!(displayShowCoords && coords);
      const tx = hasCoord ? 3 : 28.8;
      const ta = hasCoord ? void 0 : "middle";
      return displaySubline ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "text",
        {
          x: tx,
          y: "2.91",
          textAnchor: ta,
          fontFamily: "Inter, sans-serif",
          fontWeight: "600",
          fontSize: "1.55",
          letterSpacing: "0.45",
          fill: "#C8CCD0"
        },
        displayTitle
      ), /* @__PURE__ */ React.createElement(
        "text",
        {
          x: tx,
          y: "5.81",
          textAnchor: ta,
          fontFamily: "Inter, sans-serif",
          fontWeight: "600",
          fontSize: "2.0",
          letterSpacing: "0.18",
          fill: "#C8CCD0"
        },
        displaySubline
      )) : /* @__PURE__ */ React.createElement(
        "text",
        {
          x: tx,
          y: "4.70",
          textAnchor: ta,
          fontFamily: "Inter, sans-serif",
          fontWeight: "600",
          fontSize: "2.4",
          letterSpacing: "0.28",
          fill: "#C8CCD0"
        },
        displayTitle
      );
    })(),
    displayShowCoords && coords ? /* @__PURE__ */ React.createElement(
      "text",
      {
        x: "54.6",
        y: "4.46",
        textAnchor: "end",
        fontFamily: "Inter, sans-serif",
        fontWeight: "400",
        fontSize: "1.8",
        letterSpacing: "0.16",
        fill: "#C8CCD0"
      },
      coords
    ) : null
  ))), !personalise ? /* @__PURE__ */ React.createElement("div", { style: {
    marginTop: 20,
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 16
  } }, /* @__PURE__ */ React.createElement("p", { className: "body", style: { fontSize: 13, color: "var(--stone)", lineHeight: 1.6, margin: 0, flex: "1 1 320px" } }, "Photos show the standard engraving \u2014 yours will read as previewed above."), /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: function() {
        setPersonalise(true);
      },
      style: {
        padding: "14px 28px",
        border: "1px solid var(--ink)",
        background: "var(--ink)",
        color: "var(--bone)",
        fontFamily: "Inter, sans-serif",
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: "0.22em",
        textTransform: "uppercase",
        cursor: "pointer"
      }
    },
    "Personalise the engraving \xB7 +\xA33 \u2192"
  )) : /* @__PURE__ */ React.createElement("div", { style: { marginTop: 28 } }, /* @__PURE__ */ React.createElement("div", { className: "cf-cust-header", style: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 } }, /* @__PURE__ */ React.createElement("div", { className: "label" }, "Customise", modPending ? /* @__PURE__ */ React.createElement("span", { style: { marginLeft: 10, fontSize: 10, color: "var(--stone)", letterSpacing: "0.18em" } }, "\xB7 Checking\u2026") : null), /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: function() {
        setPersonalise(false);
        setTitle(normaliseEngravingInput(d.title || "").slice(0, titleMaxFor(!!d.subline, initialCoordsOn)));
        setSubline(normaliseEngravingInput(d.subline || "").slice(0, sublineMaxFor(initialCoordsOn)));
        setShowCoords(initialCoordsOn);
        setTitleError(null);
        setSublineError(null);
        setModError(null);
        validatedRef.current = true;
      },
      style: {
        padding: "6px 12px",
        border: "1px solid var(--line)",
        background: "transparent",
        fontFamily: "Inter, sans-serif",
        fontSize: 10,
        fontWeight: 500,
        letterSpacing: "0.2em",
        textTransform: "uppercase",
        cursor: "pointer",
        color: "var(--stone)"
      }
    },
    "Reset to standard"
  )), /* @__PURE__ */ React.createElement("div", { className: "cf-cust-grid", style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 8 } }, /* @__PURE__ */ React.createElement("div", { className: "label" }, subline ? "Top line \xB7 smaller" : "Line \xB7 large"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: title.length >= titleMax ? "var(--ink)" : "var(--stone)", fontVariantNumeric: "tabular-nums" } }, title.length, "/", titleMax)), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: title,
      onChange: function(e) {
        if (hasUnsupportedChars(e.target.value)) flagStripHint();
        const v = normaliseEngravingInput(e.target.value).slice(0, titleMax);
        setTitle(v);
        const bad = findBannedWord(v);
        setTitleError(bad ? '"' + bad.toUpperCase() + `" isn't allowed in engraved text.` : null);
        if (modError) setModError(null);
        validatedRef.current = false;
      },
      placeholder: (d.title || "e.g. HUGO & GRACE").toUpperCase(),
      style: {
        width: "100%",
        padding: "12px 14px",
        border: "1px solid " + (titleError ? "var(--vermilion, #C8332C)" : "var(--ink)"),
        background: "var(--bone)",
        fontFamily: "Inter, sans-serif",
        fontSize: 14,
        fontWeight: 600,
        letterSpacing: "0.04em",
        textTransform: "uppercase"
      }
    }
  ), titleError ? /* @__PURE__ */ React.createElement("div", { style: { marginTop: 6, fontSize: 11, color: "var(--vermilion, #C8332C)", lineHeight: 1.4 } }, titleError) : null), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 8 } }, /* @__PURE__ */ React.createElement("div", { className: "label" }, "Main line \xB7 larger"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: subline.length >= sublineMax ? "var(--ink)" : "var(--stone)", fontVariantNumeric: "tabular-nums" } }, subline.length, "/", sublineMax)), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: subline,
      onChange: function(e) {
        if (hasUnsupportedChars(e.target.value)) flagStripHint();
        const v = normaliseEngravingInput(e.target.value).slice(0, sublineMax);
        setSubline(v);
        const bad = findBannedWord(v);
        setSublineError(bad ? '"' + bad.toUpperCase() + `" isn't allowed in engraved text.` : null);
        if (modError) setModError(null);
        validatedRef.current = false;
      },
      placeholder: "e.g. FIRST HOME",
      style: {
        width: "100%",
        padding: "12px 14px",
        border: "1px solid " + (sublineError ? "var(--vermilion, #C8332C)" : "var(--ink)"),
        background: "var(--bone)",
        fontFamily: "Inter, sans-serif",
        fontSize: 13,
        fontWeight: 500,
        letterSpacing: "0.22em",
        textTransform: "uppercase"
      }
    }
  ), sublineError ? /* @__PURE__ */ React.createElement("div", { style: { marginTop: 6, fontSize: 11, color: "var(--vermilion, #C8332C)", lineHeight: 1.4 } }, sublineError) : null)), stripHint ? /* @__PURE__ */ React.createElement("div", { role: "status", style: {
    marginTop: 12,
    padding: "10px 12px",
    background: "var(--mist, #EEEFEB)",
    border: "1px solid var(--line, #ddd)",
    color: "var(--ink-soft, #6E7479)",
    fontSize: 12,
    lineHeight: 1.5
  } }, "Emoji and special characters can\u2019t be laser-engraved \u2014 only letters, numbers, and basic punctuation.") : null, modError ? /* @__PURE__ */ React.createElement("div", { role: "alert", style: {
    marginTop: 16,
    padding: "12px 14px",
    background: "rgba(200, 51, 44, 0.08)",
    border: "1px solid var(--vermilion, #C8332C)",
    color: "var(--vermilion, #C8332C)",
    fontSize: 12.5,
    lineHeight: 1.5
  } }, modError) : null, coords ? /* @__PURE__ */ React.createElement("div", { style: { marginTop: 20 } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: function() {
        setShowCoords(function(v) {
          return !v;
        });
      },
      style: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "12px 14px",
        width: "100%",
        border: "1px solid " + (showCoords ? "var(--ink)" : "var(--line)"),
        background: showCoords ? "var(--bone)" : "transparent",
        textAlign: "left",
        cursor: "pointer"
      }
    },
    /* @__PURE__ */ React.createElement("span", { style: {
      width: 14,
      height: 14,
      border: "1.5px solid var(--ink)",
      background: showCoords ? "var(--ink)" : "transparent",
      color: "var(--mist)",
      fontSize: 9,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    } }, showCoords ? "\u2713" : ""),
    /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, fontWeight: 600 } }, "Engrave coordinates"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10.5, color: "var(--stone)", fontVariantNumeric: "tabular-nums" } }, coords))
  )) : null, /* @__PURE__ */ React.createElement("div", { className: "caption", style: { marginTop: 16, fontSize: 10, color: "var(--stone)" } }, "Custom plates are engraved per order \u2014 allow an extra 2\u20133 working days for dispatch.")), /* @__PURE__ */ React.createElement("div", { style: {
    marginTop: 18,
    paddingTop: 14,
    borderTop: "1px solid var(--line, #ddd)",
    fontFamily: "Inter, sans-serif",
    fontSize: 11,
    lineHeight: 1.5,
    color: "var(--stone, #6E7479)"
  } }, "Preview before print. Refund within 48 hours if your kilometre can\u2019t be produced."), personalise && form ? ReactDOM.createPortal(
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("input", { type: "hidden", name: "properties[Engraving]", value: displayTitle }), displaySubline ? /* @__PURE__ */ React.createElement("input", { type: "hidden", name: "properties[Locality]", value: displaySubline }) : null, displayShowCoords && coords ? /* @__PURE__ */ React.createElement("input", { type: "hidden", name: "properties[Coordinates]", value: coords }) : null, /* @__PURE__ */ React.createElement("input", { type: "hidden", name: "properties[Personalised]", value: "yes" }), /* @__PURE__ */ React.createElement("input", { type: "hidden", name: "properties[_Laser SVG]", value: buildLaserSvg({
      title: displayTitle,
      subline: displaySubline,
      coords,
      showCoords: displayShowCoords
    }) })),
    form
  ) : null, !suppressBaseSelector && baseColor === "white" && form ? ReactDOM.createPortal(
    /* @__PURE__ */ React.createElement("input", { type: "hidden", name: "properties[Base color]", value: "White" }),
    form
  ) : null));
  if (inline) return ui;
  if (portalHost) return ReactDOM.createPortal(ui, portalHost);
  if (anchorFailed) return ui;
  return null;
}
Object.assign(window, { CfProductLabel });
window.BaseColorSelector = BaseColorSelector;
window.CfProductLabel = CfProductLabel;
})();
